import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';
import { type BackendPlacementMessage } from '@post-office/message-maker-node/placements/types';
import { noValidation } from '@post-office/message-maker-node/placements/message-helpers';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import type {
	CreatePlacementMessageConfig,
	AnyPayload,
} from '@post-office/message-template-contracts/placement-v2';
import {
	type BackendSyncMessageStage,
	type AnyBackendMessageStage,
} from '@post-office/message-maker-node/placements/types';
import { TeamworkCollectionCcpId } from '@post-office/message-template-contracts/message-template-metadata';
import type { TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

// Custom backend that fetches TCS hostname and TAP site trait to build the Confluence onboarding URL
export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: noValidation(),
		stage: () => ({
			rerankingMetadata: { productId: TeamworkCollectionCcpId },
		}),
	},
	hydrate: {
		validate: assertMessageTemplateContext,
		stage: async ({ message, request }) => {
			const { logger, statsig } = request;
			const { messageInstanceId, messageTemplateId, triggerId } = message;
			const { cloudId: tenantId } = message.context;

			if (!tenantId || typeof tenantId !== 'string') {
				logger.error(
					{ messageInstanceId, messageTemplateId, triggerId },
					'Tenant ID not available',
				);
				throw new Error('Tenant ID not available');
			}

			statsig.getExperimentValue(
				{ identifiers: { tenantId } },
				{ name: 'twcg-991-jtbd-onboarding-a-a-fo', parameter: 'isEnabled', defaultValue: false },
			);

			throw Error('Control cohort - abort hydration');
		},
	},
}));

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: () => null,
	},
});
